export default {
    tutorial: 'คู่มือการใช้งาน',
    subTutorial: 'การชำระเงิน',
    problem: 'พบปัญหาการใช้งาน ?',
    subProblem: 'โปรดระบุรายละเอียดของปัญหาได้ที่แบบฟอร์ม'
}
